const RED_HZ_LOWER = 0;
const YELLOW_HZ_LOWER = 49.9;
const GREEN_HZ = 49.91;
const YELLOW_HZ_UPPER = 50.07;
const RED_HZ_UPPER = 50.1;

export const LEVELS = {
    GREEN: 'Green',
    YELLOW: 'Yellow',
    RED: 'Red',
};

export function getLevel(value) {
    const levels = [{
        threshold: RED_HZ_LOWER,
        level: LEVELS.RED,
    }, {
        threshold: YELLOW_HZ_LOWER,
        level: LEVELS.YELLOW,
    }, {
        threshold: GREEN_HZ,
        level: LEVELS.GREEN,
    }, {
        threshold: YELLOW_HZ_UPPER,
        level: LEVELS.YELLOW,
    }, {
        threshold: RED_HZ_UPPER,
        level: LEVELS.RED,
    }];

    let result;

    levels.forEach(level => {
        if(value > level.threshold) {
            result = level.level;
        }
    });

    return result;
}
